<template>
  <div class="wrapper">
    <Header></Header>
    <Sidebar></Sidebar>
    <div class="content-box" :class="{'content-collapse':collapse}">

      <div class="content">
        <transition name="move" mode="out-in">

          <router-view></router-view>

        </transition>
        <el-backtop target=".content"></el-backtop>
      </div>
    </div>
  </div>
</template>

<script>
import Header from './Header.vue'
import Sidebar from './Sidebar.vue'
import bus from '../../../../js/bus'
export default {
  name: 'Manage',
  data () {
    return {
      collapse: false
    }
  },
  components: {
    Header,
    Sidebar
  },
  created () {
    bus.$on('collapse-content', msg => {
      this.collapse = msg
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pc/pages/back/BackManage.vue